import React from 'react';
import cx from 'classnames';
import { Icon } from 'js/components';
import { faUser, faHeadSideGear } from '@fortawesome/pro-solid-svg-icons';

function ProductManagerSearchResult({ item }) {
  return (
    <div>
      <Icon
        icon={item.is_product_manager ? faHeadSideGear : faUser}
        fixedWidth
        className={cx('icon-left', {
          'text-info': !item.is_product_manager,
          'text-success': item.is_product_manager,
        })}
      />
      {`${item.display_name || ''} (${item.username})`.trim()}
    </div>
  );
}

export default ProductManagerSearchResult;
